import { useMemo } from 'react'

import { useCard } from '@/hooks/useCard'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'
import { getCardImage } from '@/utils/cardUtil'

type Props = {
  name?: string
  scryfallId?: string
} & Parameters<typeof useCard>[0]

export const useCardFaceProps = ({ cardId, enabled, name, scryfallId }: Props) => {
  const { card, hasError, loading } = useCard({ cardId, enabled })
  const alternateArtId = useReduxSelector((s) => selectors.alternateArt(s, cardId))
  const effectiveScryfallId = alternateArtId || card?.scryfallId || scryfallId

  return useMemo(() => {
    const flags = {
      hasContentWarning: card?.hasContentWarning,
      hasError,
      isBanned: card?.isBanned,
      isUnofficial: card?.isUnofficial,
      loading,
    }

    const { imageBack, nameBack } = card || {}
    const back =
      imageBack && nameBack
        ? {
            ...flags,
            image: getCardImage({ face: 'back', scryfallId: effectiveScryfallId }) || imageBack,
            name: nameBack,
          }
        : undefined

    return {
      back,
      front: {
        ...flags,
        image: getCardImage({ scryfallId: effectiveScryfallId }) || card?.image,
        name: card?.nameFront || card?.name || name,
      },
    }
  }, [card, effectiveScryfallId, hasError, loading, name])
}
